(function (angular) {
    'use strict';

    angular.module('messenger')

        /**
         *
         */
        .factory('facebookService',
            ['$http', '$q', 'portalConfig',
                function ($http, $q, portalConfig) {

                    var urlBase = portalConfig.urlBase;
                    //urlBase = "http://localhost:8002";
                    var fac = {
                        getLongAccessToken: getLongAccessToken,
                        getPages: getPages,
                        savePageToComapi: savePageToComapi,
                        deleteFacebookConfig: deleteFacebookConfig,
                        getPageFromComapi: getPageFromComapi,
                        getAppId: getAppId,
                        getTags: getTags
                    };

                    return fac;

                    function getTags(apiSpaceId) {
                        return $http.get(urlBase + "/apispaces/" + apiSpaceId + "/channels/facebook/tags").then(function (response) {
                            return response.data;
                        }).catch(function (error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        });
                    }

                    function deleteFacebookConfig(apispaceId) {
                        return $http.delete(urlBase + "/apispaces/" + apispaceId + "/channels/facebook")
                            .then(deleteFacebookConfigComplete)
                            .catch(deleteFacebookConfigFailed);

                        function deleteFacebookConfigComplete(response) {
                            return response.data;
                        }

                        function deleteFacebookConfigFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    function getAppId(apispaceId) {
                        return $http.get(urlBase + "/apispaces/" + apispaceId + "/channels/facebook/appId")
                            .then(getAppIdComplete)
                            .catch(getAppIdFailed);

                        function getAppIdComplete(response) {
                            return response.data;
                        }

                        function getAppIdFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    function getLongAccessToken(apispaceId, shortLiveToken) {
                        return $http.get(urlBase + "/apispaces/" + apispaceId + "/channels/facebook/longLiveToken?token=" + shortLiveToken)
                            .then(getLongAccessTokenComplete)
                            .catch(getLongAccessTokenFailed);

                        function getLongAccessTokenComplete(response) {
                            return response.data;
                        }

                        function getLongAccessTokenFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }


                    /**
                     * @param {string} longToken - longToken
                     */
                    function getPages(longToken) {
                        return $http.get(`${portalConfig.graphApiBaseUrl}/${portalConfig.fbApiVersion}/me/accounts?access_token=${longToken}`)
                            .then(getPagesComplete)
                            .catch(getPagesFailed);

                        function getPagesComplete(response) {
                            return response.data;
                        }

                        function getPagesFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    function savePageToComapi(apispaceId, id, name, access_token, allowPhoneNumber) {
                        var data = {
                            pageId: id,
                            name: name,
                            access_token: access_token,
                            allowPhoneNumber: allowPhoneNumber
                        };
                        return $http.put(urlBase + "/apispaces/" + apispaceId + "/channels/facebook", data)
                            .then(savePageToComapiComplete)
                            .catch(savePageToComapiFailed);

                        function savePageToComapiComplete(response) {
                            return response.data;
                        }

                        function savePageToComapiFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    function getPageFromComapi(apispaceId) {
                        return $http.get(urlBase + "/apispaces/" + apispaceId + "/channels/facebook")
                            .then(getPageToComapiComplete)
                            .catch(getPageToComapiFailed);

                        function getPageToComapiComplete(response) {
                            return response.data;
                        }

                        function getPageToComapiFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                }]);

})(window.angular);
